import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M14,3 L14,2 L2,2 L2,3 L14,3 Z M14,6.5 L14,5.5 L5,5.5 L5,6.5 L14,6.5 Z M5,13.5 L5,12.5 L14,12.5 L14,13.5 L5,13.5 Z M14,10 L14,9 L2,9 L2,10 L14,10 Z"
        fill-opacity=".89999998"
        fill-rule="evenodd"
      />
    </svg>
  )
}
const FontRightIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontRightIcon
